/* hairboutique — interactions thème (vanilla, sans dépendance) */
(function () {
  'use strict';

  var euro = function (cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2 }) + ' €';
  };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* --- Navbar : état au scroll (> 40px) -------------------------------- */
  var header = $('[data-navbar]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Révélation au scroll -------------------------------------------- */
  var reveals = $$('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) {
      if (el.dataset.delay) el.style.setProperty('--d', el.dataset.delay);
      io.observe(el);
    });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* --- Ouverture / fermeture de panneaux génériques -------------------- */
  function lock(state) { document.body.classList.toggle('is-locked', state); }

  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea';

  function bindPanel(openSelector, panel, scrim) {
    if (!panel) return;
    panel.setAttribute('aria-hidden', 'true');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.classList.add('is-open');
      lock(true);
      var f = panel.querySelector(FOCUSABLE);
      if (f) f.focus();
    }
    function close() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.classList.remove('is-open');
      lock(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    $$(openSelector).forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    $$('[data-close]', panel).forEach(function (b) {
      b.addEventListener('click', close);
    });
    if (scrim) scrim.addEventListener('click', close);
    panel._open = open;
    panel._close = close;

    document.addEventListener('keydown', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = panel.querySelectorAll(FOCUSABLE);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  var scrim = $('.scrim');
  bindPanel('[data-nav-open]', $('.navmenu'), scrim);
  var drawer = $('.drawer');
  bindPanel('[data-cart-open]', drawer, scrim);

  /* --- Panier AJAX ----------------------------------------------------- */
  function renderCart(cart) {
    var count = cart.item_count;
    $$('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    if (!drawer) return;
    var items = $('.drawer__items', drawer);
    var foot = $('.drawer__foot', drawer);
    var recos = $('.drawer__recos', drawer);

    if (!cart.items.length) {
      items.innerHTML = '<div class="drawer__empty"><p>Votre panier est vide.</p>'
        + '<a class="btn btn--ghost" href="/collections/appareils">Voir la collection</a></div>';
      if (foot) foot.style.display = 'none';
      if (recos) recos.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    if (recos) recos.style.display = '';

    items.innerHTML = cart.items.map(function (it) {
      return '<div class="line-item" data-key="' + it.key + '">'
        + '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : '') + '" alt="" width="72" height="72" loading="lazy">'
        + '<div class="line-item__info">'
        + '<div class="line-item__title">' + it.product_title + '</div>'
        + (it.variant_title && it.variant_title !== 'Default Title' ? '<div>' + it.variant_title + '</div>' : '')
        + '<div class="line-item__row">'
        + '<span class="line-item__price">' + euro(it.final_price) + '</span>'
        + '<span class="qstep"><button data-qty="' + it.key + '" data-d="-1" aria-label="Retirer un">&minus;</button>'
        + '<span class="qstep__v">' + it.quantity + '</span>'
        + '<button data-qty="' + it.key + '" data-d="1" aria-label="Ajouter un">+</button></span></div>'
        + '<button class="line-item__remove" data-remove="' + it.key + '">Retirer</button>'
        + '</div></div>';
    }).join('');

    var totalEl = $('.drawer__total b', drawer);
    if (totalEl) totalEl.textContent = euro(cart.total_price);

    $$('[data-remove]', items).forEach(function (b) {
      b.addEventListener('click', function () { changeCart(b.dataset.remove, 0); });
    });
    $$('[data-qty]', items).forEach(function (b) {
      b.addEventListener('click', function () {
        var li = b.closest('.line-item');
        var current = cart.items.filter(function (i) { return i.key === b.dataset.qty; })[0];
        if (current) changeCart(b.dataset.qty, current.quantity + parseInt(b.dataset.d, 10));
      });
    });
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeCart(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(form, btn) {
    var data = new FormData(form);
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Ajout…'; }
    fetch('/cart/add.js', { method: 'POST', body: data })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { throw new Error(res.description || 'Ajout impossible'); }
        return refreshCart();
      })
      .then(function () {
        if (drawer && drawer._open) drawer._open();
      })
      .catch(function (err) { alert(err.message); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Ajouter au panier'; }
      });
  }

  $$('form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(form, form.querySelector('[type=submit]'));
    });
  });
  $$('[data-atc-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.getElementById('ProductForm');
      if (form) { form.requestSubmit ? form.requestSubmit() : form.querySelector('[type=submit]').click(); }
    });
  });
  refreshCart();

  /* --- Sélection de variante ------------------------------------------- */
  $$('[data-variant-picker]').forEach(function (picker) {
    var form = document.getElementById(picker.dataset.variantPicker);
    picker.addEventListener('click', function (e) {
      var opt = e.target.closest('.variant-opt');
      if (!opt) return;
      $$('.variant-opt', picker).forEach(function (o) { o.classList.remove('is-active'); });
      opt.classList.add('is-active');
      if (form) {
        var input = form.querySelector('[name=id]');
        if (input) input.value = opt.dataset.variantId;
      }
      var priceEl = $('[data-price-target]');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    });
  });

  /* --- Quantité (steppers fiche produit) ------------------------------- */
  $$('.qty').forEach(function (q) {
    var input = $('input', q);
    $$('button', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += (b.dataset.step === 'up' ? 1 : -1);
        input.value = Math.max(1, v);
      });
    });
  });

  /* --- Galerie produit ------------------------------------------------- */
  $$('[data-gallery]').forEach(function (gal) {
    var main = $('.gallery__main img', gal);
    $$('.gallery__thumb', gal).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        $$('.gallery__thumb', gal).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        main.src = thumb.dataset.full;
        main.alt = thumb.querySelector('img').alt;
      });
    });
  });

  /* --- Accordéons fiche produit : ouverture/fermeture fluide ----------- */
  $$('.acc').forEach(function (acc) {
    var head = acc.querySelector('.acc__head');
    var body = acc.querySelector('.acc__body');
    if (!head || !body) return;
    head.addEventListener('click', function (e) {
      e.preventDefault();
      if (body._anim) return;
      body._anim = true;
      var opening = !acc.open;
      if (opening) acc.open = true;
      body.style.overflow = 'hidden';
      body.style.height = (opening ? 0 : body.scrollHeight) + 'px';
      body.style.opacity = opening ? 0 : 1;
      body.getBoundingClientRect();
      body.style.height = (opening ? body.scrollHeight : 0) + 'px';
      body.style.opacity = opening ? 1 : 0;
      var done = function (ev) {
        if (ev && ev.propertyName && ev.propertyName !== 'height') return;
        body.removeEventListener('transitionend', done);
        body.style.height = '';
        body.style.opacity = '';
        body.style.overflow = '';
        if (!opening) acc.open = false;
        body._anim = false;
      };
      body.addEventListener('transitionend', done);
      setTimeout(done, 650);
    });
  });

  /* --- Sticky add-to-cart mobile --------------------------------------- */
  var sticky = $('.sticky-atc');
  var anchor = $('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var sObs = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    });
    sObs.observe(anchor);
  }

  /* --- Newsletter / formulaires : focus état --------------------------- */
  /* (Le formulaire customer natif Shopify gère l'envoi ; rien à intercepter.) */

  /* --- Bannière cookies (RGPD) ----------------------------------------- */
  var cookie = $('.cookie');
  if (cookie) {
    var CONSENT_KEY = 'hb_consent_v1';
    var stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      setTimeout(function () { cookie.classList.add('is-visible'); }, 900);
    }
    function applyConsent(granted) {
      localStorage.setItem(CONSENT_KEY, granted ? 'all' : 'essential');
      cookie.classList.remove('is-visible');
      try {
        if (window.Shopify && Shopify.customerPrivacy) {
          Shopify.customerPrivacy.setTrackingConsent({
            analytics: granted, marketing: granted,
            preferences: granted, sale_of_data: false
          }, function () {});
        }
      } catch (e) { /* API consentement indisponible — choix mémorisé localement */ }
    }
    $$('[data-cookie-accept]', cookie).forEach(function (b) {
      b.addEventListener('click', function () { applyConsent(true); });
    });
    $$('[data-cookie-refuse]', cookie).forEach(function (b) {
      b.addEventListener('click', function () { applyConsent(false); });
    });
  }
  $$('[data-cookie-reopen]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (cookie) cookie.classList.add('is-visible');
    });
  });

  /* --- Recherche predictive ------------------------------------------- */
  var searchPanel = $('.search-panel');
  if (searchPanel) {
    bindPanel('[data-search-open]', searchPanel, scrim);
    var sInput = $('[data-predictive-input]', searchPanel);
    var sResults = $('[data-predictive-results]', searchPanel);
    var sTimer = null;

    function money(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return v || '';
      return n.toFixed(2).replace('.', ',') + ' €';
    }

    function renderResults(products) {
      if (!products.length) {
        sResults.innerHTML = '<p class="search-empty">Aucun produit trouvé.</p>';
        return;
      }
      sResults.innerHTML = products.map(function (p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        if (img) img = img.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2');
        return '<a class="search-hit" href="' + p.url + '">'
          + (img ? '<img src="' + img + '" alt="" width="56" height="56" loading="lazy">' : '<span class="search-hit__ph"></span>')
          + '<span class="search-hit__info"><span class="search-hit__title">' + p.title + '</span>'
          + '<span class="search-hit__price">' + money(p.price) + '</span></span></a>';
      }).join('');
    }

    function query(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products);
        })
        .catch(function () { sResults.innerHTML = ''; });
    }

    if (sInput) {
      sInput.addEventListener('input', function () {
        var q = sInput.value.trim();
        clearTimeout(sTimer);
        if (q.length < 2) { sResults.innerHTML = ''; return; }
        sTimer = setTimeout(function () { query(q); }, 220);
      });
    }
  }
})();
